"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toV1Shape = toV1Shape;
exports.toV1Taxes = toV1Taxes;
function toV1Shape(computation, order) {
    // `item.discountTotal` de la v1 (ItemHelpers.getOrderComputedItems,
    // item.helpers.ts:768-790) ne compte QUE les remises article des promotions :
    // ni les remises de commande des promotions, ni les remises utilisateur — et
    // `item.total` vaut `subtotal − discountTotal` sur cette base. Le moteur, lui,
    // porte dans `promotionDiscount` la part de ligne des remises de commande
    // (nécessaire pour que la ventilation TVA ferme le total) : la forme v1 est
    // donc reconstruite depuis les `itemsDiscounts` des promotions, pas depuis
    // `DiscountedItem.promotionDiscount`.
    const itemDiscounts = new Map();
    for (const promotion of computation.promotions) {
        for (const discount of promotion.itemsDiscounts) {
            itemDiscounts.set(discount.referenceId, (itemDiscounts.get(discount.referenceId) ?? 0) + discount.discount);
        }
    }
    const items = computation.items.map((item) => {
        const discountTotal = itemDiscounts.get(item.referenceId) ?? 0;
        return {
            referenceId: item.referenceId,
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            baseTotal: item.baseTotal,
            extrasTotal: item.extrasTotal,
            subtotal: item.subtotal,
            discountTotal,
            total: item.subtotal - discountTotal,
        };
    });
    const promotions = computation.promotions.map((promotion) => {
        const totalItemsDiscount = promotion.itemsDiscounts.reduce((sum, discount) => sum + discount.discount, 0);
        return {
            promotionId: promotion.promotionId,
            // `computedDiscount` est le champ historique : la v1 y recopie
            // `totalDiscount` (promotion.ts:1300-1310).
            computedDiscount: promotion.totalDiscount,
            orderDiscount: promotion.orderDiscount,
            totalDiscount: promotion.totalDiscount,
            totalItemsDiscount,
            itemsDiscounts: promotion.itemsDiscounts.map((discount) => ({ ...discount })),
        };
    });
    const shape = {
        mode: order.mode,
        items,
        promotions,
        discounts: [...(order.discounts ?? [])],
        deliveryFees: computation.deliveryFees,
        subtotal: computation.subtotal,
        total: computation.total,
        // `itemsTotal` de la v1 : somme des totaux de ligne au sens v1 (remises
        // article des promotions déduites, remises utilisateur exclues).
        itemsTotal: items.reduce((sum, item) => sum + item.total, 0),
        // `discountsTotal` de la v1 = montant des seules remises UTILISATEUR
        // (`computedTotalDiscounts`, promotion.ts:241) — les promotions ont leurs
        // propres champs.
        discountsTotal: computation.discountsTotal,
    };
    if (order.deliveryZone)
        shape.deliveryZone = order.deliveryZone;
    return shape;
}
// `tax` est l'objet de `order.taxes` portant cet identifiant (la v1 le recopie
// tel quel dans `IOrderTaxes`). Une taxe absente de la commande — cas
// anormal : seule la taxe des frais de livraison vient de l'appelant (R8) — est
// reconstruite depuis le `TaxRef` du moteur, sans nom.
function toV1Taxes(computation, order) {
    const byId = new Map();
    for (const tax of order.taxes ?? []) {
        byId.set(tax._id, tax);
    }
    return computation.vat.map((line) => ({
        tax: byId.get(line.tax.id) ?? { _id: line.tax.id, name: '', rate: line.tax.ratePercent },
        rate: line.tax.ratePercent,
        tvaAmount: line.vat,
        htAmount: line.ht,
        ttcAmount: line.ttc,
    }));
}
